import { useNavigate } from 'react-router-dom';
import Dropdown from 'src/components/atoms/dropdown/dropdown';
import admLogo from '../../../shared/adm-logo.png';
import styles from './header.module.scss';
import { RootState, useAppDispatch } from 'src/reducers';
import { useSelector } from 'react-redux';
import { Icon } from 'src/components/atoms/icon';
import { isSystem } from '../../../utils/auth-utils';
import { logout, resetAuthState } from '../../../reducers/authentication.reducer';
import Flex from '../../atoms/flex/flex';
import Avatar from '../../atoms/avatar/avatar';
import { AVATAR_IMAGE_FALLBACK } from '../../../config/constants';
import { EDIT_ACCOUNT_PERMISSION, isAuthorizedToHandleCapability } from '../../../utils/capability-utils';
import Button from 'src/components/atoms/button/button';
import { useState } from 'react';
import { toggleMenu } from 'src/reducers/hamburg-menu.reducer';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const user = useSelector((state: RootState) => state.authentication.user);

  const handleClick = () => {
    navigate('/');
  };

  const doLogout = () => {
    dispatch(logout());
    dispatch(resetAuthState());
    navigate('/login');
  };

  return (
    <div className={styles.header}>
      <img src={admLogo} alt="Logo Adamantic" onClick={handleClick} />
      {user && (
        <Dropdown className={styles.profileButton}>
          <Dropdown.Toggle>
            <div className={styles.dropdownToggleWrapper}>
              <Avatar size="xs" image="" fallback={AVATAR_IMAGE_FALLBACK} />
              <div className={styles.dropdownToggleUserName}>
                {user.anagraphic ? `${user.anagraphic?.firstname} ${user.anagraphic?.lastname}` : user.email}
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Container position="bottom_right">
            {!isSystem(user.authority.name as string) && isAuthorizedToHandleCapability(user, EDIT_ACCOUNT_PERMISSION) && (
              <Dropdown.Item onClick={() => navigate(`/anagraphic/${user?.id}`)}>
                <Flex container alignItems="center" gap={10}>
                  <Icon content="users" className={styles.sidenavIcon} />
                  <div>Anagrafica</div>
                </Flex>
              </Dropdown.Item>
            )}
            <Dropdown.Item onClick={() => navigate(`/change-password/${user.id}`)}>
              <Flex container alignItems="center" gap={10}>
                <Icon content="password" />
                <div>Cambio password</div>
              </Flex>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => doLogout()}>
              <Flex container alignItems="center" gap={10}>
                <Icon content="logout" className={styles.iconDropdown} />
                <div>Logout</div>
              </Flex>
            </Dropdown.Item>
          </Dropdown.Container>
        </Dropdown>
      )}
      <Button className={styles.hamburgButton} onClick={() => dispatch(toggleMenu())}>
        <Icon content="blockOrder" className={styles.icon} />
      </Button>
    </div>
  );
};

export default Header;
